import api from './api'

export default {
  methods: {
    updateProfile(values) {
      let tasks = [];
      let newInformation = {};
      let fields = ['displayName', 'photoURL']
      let user = this.$auth.user()
      fields.forEach(key => {
        if ( values[key] && values[key]!=this.userInfo[key] ) {
          newInformation[key] = values[key]
        }
      })
      if ( Object.keys(newInformation).length>0 ) {
        tasks.push( user.updateProfile(newInformation).then(e => { return true }) )
      }
      if ( values['email'] && values['email']!=this.userInfo['email'] ) {
        tasks.push( this.api('user', {email: values['email']}).then(e => {
          return 'reload';
        }) )
      }
      let currentUser = this.$store.state.user.user
      this.$store.commit('UPDATE_USER', { user : { ...currentUser, ...newInformation } })
      return Promise.all(tasks);
    }
  },
  computed: {
    userInfo() {
      const user = this.$store.state.user.user
      const metadata = this.$store.state.user.metadata
      if (!user || !user.uid) return {}
      const info = {}
      const fields = ['displayName', 'phoneNumber', 'photoURL', 'uid'] // , 'email', 'emailVerified'
      fields.forEach(k => { info[k] = user[k] })
      if ( metadata )
        ['email'].forEach(k => { info[k] = metadata[k] })
      if (info.uid && !info.photoURL) {
        info['photoURL'] = `https://robohash.org/${info.uid}.png`
      }    
      info['lastSignInTime'] = user.metadata.lastSignInTime
      return info
    },
  },
  mixins: [api]
}
